import { Injectable, inject } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { Observable, catchError, map, of } from 'rxjs';

import { ActivityDefinitionDto } from '@treetop/shared/model';

import { setGuidelineActionForMedication } from './ActivityDefinitionUtil';
import { getPlanActionForm } from './FormResolver';
import { MedicalComponentService } from './medical-component.service';

@Injectable({
  providedIn: 'root',
})
export class MedicationRequestService {
  private medicalComponentService = inject(MedicalComponentService);

  public getMedicationRequests(code: string, version: string): Observable<ActivityDefinitionDto[]> {
    return this.medicalComponentService.loadMedicationRequests(code, version).pipe(
      map((result) => {
        return [...result];
      }),
      catchError((error) => of([])),
    );
  }

  public convertActivityToMedicationRequest(data: ActivityDefinitionDto[]): UntypedFormArray {
    const medicationRequests = new UntypedFormArray([]);

    data.forEach((ad) => {
      const actionChildren = getPlanActionForm({ activityDefinition: {} });

      setGuidelineActionForMedication(
        {
          originalDefinition: ad,
          overwrittenDefinition: ad,
        },
        actionChildren,
        null,
        null,
        null,
      );

      medicationRequests.push(actionChildren);
    });
    return medicationRequests;
  }
}
